import { Link } from "react-scroll";

const About = () => {
  return (
    <section className="py-24 bg-secondary" id="about">
      <div className="container mx-auto max-w-4xl">
        <div className="mb-12">
          <p className="text-accent uppercase tracking-widest text-sm mb-4">
            Enfoque profesional
          </p>

          <h2 className="text-3xl md:text-4xl font-bold mb-8">
            Sistemas pensados para evolucionar,
            <span className="block text-accent">no solo para funcionar.</span>
          </h2>
        </div>

        <div className="space-y-6 text-paragraph leading-relaxed text-lg">
          <p>
            He sido responsable del diseño y construcción de sistemas backend
            completos, trabajando bajo restricciones reales de negocio y tomando
            decisiones técnicas con impacto estructural.
          </p>

          <p>
            No me limito a implementar funcionalidades. Analizo el dominio,
            defino límites claros entre módulos y establezco arquitecturas que
            permitan crecimiento sin deterioro.
          </p>

          <p>
            Trabajo principalmente con Java y TypeScript, priorizando separación
            de responsabilidades, control de acceso, trazabilidad y
            sostenibilidad a largo plazo.
          </p>
        </div>

        <div className="mt-12">
          <Link to="portfolio" smooth duration={500}>
            <button className="bg-accent hover:bg-accent-hover px-8 py-3 font-medium transition-all">
              Ver proyectos
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default About;
